"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessRuleTaskViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class BusinessRuleTaskViewModel extends ActivityViewModel_1.ActivityViewModel {
}
exports.BusinessRuleTaskViewModel = BusinessRuleTaskViewModel;
//# sourceMappingURL=BusinessRuleTaskViewModel.js.map